/**
 * Small building blocks shared across the CP sub-panels.
 * Keeping these together avoids polluting the wizard/_shared module.
 */
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";


export function CPField({ label, testId, unit, children, span = 1 }) {
  return (
    <div className={`space-y-0.5 col-span-${span}`}>
      <Label className="text-[9px] uppercase tracking-widest font-mono text-slate-500">
        {label}{unit && <span className="text-slate-400"> · {unit}</span>}
      </Label>
      {children}
      {testId && <span data-testid={testId} className="hidden" />}
    </div>
  );
}


export function CPTextInput({ value, onChange, placeholder, testId, type = "text" }) {
  return (
    <Input type={type} value={value ?? ""} onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder} data-testid={testId}
            className="h-8 text-[12px]" />
  );
}


export function CPNumberInput({ value, onChange, testId, step = "1", min }) {
  return (
    <Input type="number" step={step} min={min} value={value ?? ""}
            onChange={(e) => onChange(e.target.value === "" ? null : Number(e.target.value))}
            data-testid={testId} className="h-8 text-[12px] font-mono" />
  );
}


export function CPTextArea({ value, onChange, rows = 3, placeholder, testId }) {
  return (
    <Textarea value={value ?? ""} onChange={(e) => onChange(e.target.value)}
                rows={rows} placeholder={placeholder} data-testid={testId}
                className="text-[12px]" />
  );
}


export function StatusBadge({ status }) {
  const map = {
    draft:                "bg-slate-100 text-slate-700",
    ready_for_review:     "bg-sky-100 text-sky-700",
    requires_information: "bg-amber-100 text-amber-700",
    signed:               "bg-emerald-100 text-emerald-700",
    superseded:           "bg-slate-200 text-slate-500 line-through",
  };
  return (
    <span className={`px-2 py-0.5 rounded text-[10px] uppercase tracking-widest font-mono ${map[status] || "bg-slate-100 text-slate-700"}`}>
      {status || "—"}
    </span>
  );
}


export function ChecklistRow({ ok, label }) {
  return (
    <div className="flex items-center gap-2 text-[11px] font-mono">
      <span className={`inline-block w-3 h-3 rounded-full ${ok ? "bg-emerald-500" : "bg-slate-300"}`} />
      <span className={ok ? "text-slate-800" : "text-slate-500"}>{label}</span>
    </div>
  );
}
